/* eslint-disable prettier/prettier */
import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ModalContentProps {
  status: string | null
  email?: string | null
  message?: string | null
  handleClose: () => void
  handleYesClick: () => void
}

const ModalContent: React.FC<ModalContentProps> = ({ status, email, handleClose, handleYesClick }) => {
  const { t } = useTranslation()

  const getContent = () => {
    switch (status) {
      case 'Success':
        return {
          title: t('AppLabels.resetActivationCode'),
          content: t('AppLabels.confirmResetActivation'),
          highlight: `${t('AppLabels.activationCodeSent')} ${email}`,
          actions: [
            { label: t('AppLabels.no'), onClick: handleClose, className: 'button outlined' },
            { label: t('AppLabels.yes'), onClick: handleYesClick, className: 'button contained' }
          ]
        }
      case 'Package Subscribed':
        return {
          title: t('AppLabels.customerTitle'),
          highlight: t('AppLabels.packageSubscribedContent'),
          actions: [
            { label: t('AppLabels.understand'), onClick: handleClose, className: 'button contained' }
          ]
        }
      case 'New Customer':
        return {
          title: t('AppLabels.customerTitle'),
          highlight: t('AppLabels.newCustomerContent'),
          actions: [
            { label: t('AppLabels.understand'), onClick: handleClose, className: 'button contained' }
          ]
        }
      default:
        return null
    }
  }

  const content = getContent()

  if (!content) return null

  return (
    <>
      <Typography className='title'>{content.title}</Typography>
      {content.content && <Typography className='content'>{content.content}</Typography>}
      <Typography className='highlight'>{content.highlight}</Typography>
      <Box className='actions'>
        {content.actions.map((action, index) => (
          <Button key={index} className={action.className} onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      </Box>
    </>
  )
}

export default ModalContent